var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionableGuides({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "#4B1598"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8234 16.9734L26.7578 23L32.8234 29.0265C32.933 28.7973 32.9996 28.544 32.9996 28.2734V17.7265C32.9996 17.4559 32.933 17.2026 32.8234 16.9734Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2414 15.9688H14.757C14.4864 15.9688 14.2331 16.0353 14.0039 16.1449L21.7564 23.8583C22.4418 24.5438 23.5565 24.5438 24.242 23.8583L31.9945 16.1449C31.7653 16.0353 31.512 15.9688 31.2414 15.9688Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1762 16.9734C13.0665 17.2026 13 17.4559 13 17.7265V28.2734C13 28.544 13.0665 28.7974 13.1762 29.0265L19.2418 23L13.1762 16.9734Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9289 23.8286L25.0705 24.6869C23.9284 25.829 22.0699 25.829 20.9278 24.6869L20.0695 23.8286L14.0039 29.8551C14.2331 29.9647 14.4864 30.0312 14.757 30.0312H31.2414C31.512 30.0312 31.7653 29.9647 31.9945 29.8551L25.9289 23.8286Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionableGuides);
export default __webpack_public_path__ + "static/media/actionable-guides.4465f13a2c37a845c199b65fe0333c39.svg";
export { ForwardRef as ReactComponent };